/* tslint:disable:variable-name */
import { BaseModel } from '../../_base/crud';

export class DeviceInventoryModel extends BaseModel {
  active: boolean;
  company_id: string;
  date_assigned: any;
  date_last_sync: any;
  date_procured: any;
  device_id: number;
  id: number;
  last_battery_value: number;
  last_signal_strength: number;
  office_id: number;
  patient: number;
  serial_id: string;
  patient_id: any;
  device_name: any;
  deviceFormController: any;
}
